import React,{useState} from "react";
import { motion } from "framer-motion";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { ArrowRight } from "lucide-react";
import "app.scss";
import { useNavigate } from "react-router-dom";
import NavHeader from "components/Navbar";
import Accordion from 'react-bootstrap/Accordion';
import data3 from '../db/data.json'
import { FaChartBar, FaSearch, FaCog, FaShieldAlt } from "react-icons/fa";
import globe from '../assets/images/globe.svg'
import sheild from '../assets/images/sheild.svg'
import img from '../assets/images/euaiimg.png'

const EUAIActLandingPage = () => {
  
  const navigate = useNavigate();
  const [bgColor, setBgColor] = useState("rgb(180, 25, 102)");
  
  const handleShowModal = () => {
    navigate("/assessment");
  };


  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.3},
  };

  return (

    //header section
    <motion.section {...fadeIn}>
    <div className="min-vh-100">
     
      <div style={{position:"sticky",top:"0",zIndex:"100"}}>
      <NavHeader/>
      </div>
        <div className="media-div-second gap-3">
          <div className="d-flex align-items-center justify-content-start flex-column media-width-forth">
        <Container className="py-5 text-start head-font px-0">
        <h2 className=" mb-3  media-font-new">EU AI Act Compliance Checker</h2>

        <p 
            className="text-muted body-font display-4 display-md-4 fs-5 fw-normal text-start">
            Ensuring AI compliance, innovation, and responsibility across the
            EU.
          </p>
         
        </Container>
     
        <Container className="media-padding  px-0">
          <p
            className="text-muted body-font display-4 display-md-4 fs-5 fw-normal text-start"
            style={{ maxWidth: "800px" , lineHeight:"2.1rem" , fontSize:"1.357rem"}}
          >
            EU AI Act,<span className="fw-bold"> (Regulation (EU) 2024/1689)</span> establishes a harmonized legal
            framework to regulate the use of artificial intelligence across the
            European Union, ensuring the safe, ethical, and trustworthy
            development and deployment of AI systems.
            
          </p>
        </Container>
        <div className="mt-3 media-div-third">
        <Container className="px-0">
      <Button
            className="rounded py-2 px-3 text-white fs-5  new-btn"
           
            size="lg"
            onClick={handleShowModal}
            // onMouseEnter={() => setBgColor("rgb(136, 38, 87)")}
            // onMouseLeave={() => setBgColor("rgb(180, 25, 102)")}
          >
            Start Assessment
            <ArrowRight className="ms-3 h-2 w-2" />
          </Button>
          </Container>  
          </div>
        </div>
        <div className="d-flex align-items-start justify-content-center media-width-second">
          {/* <div className="d-flex align-items-center justify-content-start px-4 py-5 flex-column gap-2 rounded shadow-pink media-width-third" style={{border:"1px solid lightgray"}}>
            <div className="w-100 ">
            <div className="w-25 py-2 rounded skeleton-loader" style={{backgroundColor:"lightgray"}}></div>
            </div>
            <div className="w-100 py-2 rounded skeleton-loader" style={{backgroundColor:"lightgray"}}></div>
            <div className="w-100 mb-4">
              <div className="w-75 py-2 rounded skeleton-loader" style={{backgroundColor:"lightgray"}}></div>
            </div>
            <div className="w-100 px-3 py-2 rounded d-flex align-items-center justify-content-start gap-3" style={{border:"1px solid lightgray"}}>
              <div className="rounded-circle d-flex align-items-center justify-content-center skeleton-loader" style={{height:"50px",width:"50px",backgroundColor:"lightgray"}}>
                <img style={{height:"20px"}} src={sheild} alt="sheild"/>
              </div>
              <div className="d-flex align-item-center justify-content-start flex-column gap-2 w-50">
                <div className="w-100 rounded py-2 skeleton-loader" style={{backgroundColor:"lightgray"}}></div>
                <div className="w-100 rounded py-2 skeleton-loader" style={{backgroundColor:"lightgray"}}></div>
              </div>
            </div>
            <div className="w-100 px-3 py-2 rounded d-flex align-items-center justify-content-start gap-3" style={{border:"1px solid lightgray"}}>
              <div className="rounded-circle d-flex align-items-center justify-content-center skeleton-loader-second" style={{height:"50px",width:"50px",backgroundColor:"lightblue"}}>
                <img src={robot} alt="robot"/>
              </div>
              <div className="d-flex align-item-center justify-content-start flex-column gap-2 w-50">
                <div className="w-100 rounded py-2 skeleton-loader" style={{backgroundColor:"lightgray"}}></div>
                <div className="w-100 rounded py-2 skeleton-loader" style={{backgroundColor:"lightgray"}}></div>
              </div>
            </div>
          </div> */}
          <img src={img} alt="robot" style={{height:"300px",aspectRatio:"3/2"}}/>
          </div>
        </div>
     
        {/* goals section */}
        
        <div className="section-padding inline-padding">
        <h2 className="display-4 display-md-4 display-sm-6 fs-sm-5 fw-normal  text-md-center text-center mb-5 pb-3 media-font head-font">Goals</h2>          <Row  className="row row-cols-1 row-cols-md-3 g-4 " >
              <Col  md={4} className="mb-4">
                  <div className="h-100 text-center p-3 rounded" style={{border:"1px solid rgb(176, 171, 174)"}}>
                    <div>
                      <div className="mb-3"><i class="bi bi-lightbulb" style={{fontSize:"45px"}}></i></div>
                      <div className="fs-5 fw-normal mb-2 media-font">Promote Innovation</div>
                      <div className="text-muted">Supporting AI development while ensuring ethical standards and responsible practices.
                      </div>
                    </div>
                  </div>
              
              </Col>
               <Col  md={4} className="mb-4">
               <div className="h-100 text-center p-3 rounded" style={{border:"1px solid rgb(176, 171, 174)"}}>
                 <div>
                   <div className="mb-3"><img src={globe} alt="globe" style={{marginBlock:"10px"}}/></div>
                   <div className="fs-5 fw-normal mb-2  media-font">Ensure Safety and Rights</div>
                   <div className="text-muted">
                   Protecting fundamental rights and ensuring AI systems operate safely and transparently.
                   </div>
                 </div>
               </div>
           
           </Col>
            <Col md={4} className="mb-4">
            <div className="h-100 text-center p-3 rounded" style={{border:"1px solid rgb(176, 171, 174)"}}>
              <div>
                <div className="mb-3"><img src={sheild} alt="sheild" style={{marginBlock:"10px"}}/></div>
                <div className="fs-5 fw-normal mb-2 media-font">Prevent Market Fragmentation</div>
                <div className="text-muted">
                Creating a unified regulatory framework across the EU to ensure consistent standards.
                </div>
              </div>
            </div>
        </Col>
           
          </Row>
        </div>
        

    

            {/* risk based classification section */}
        <div className="d-flex align-items-center justify-content-center flex-column section-padding inline-padding">
        <h2 className="display-4 display-md-4 display-sm-6 fs-sm-5 fw-normal  text-md-center text-center mb-5 pb-3 head-font media-font">Risk-Based Classification</h2>          <Row className="d-flex flex-column align-items-center w-100 justify-content-center">
            {/* {data2?.map((risk, index) => ( */}
              <Col  md={6} className="mb-4 w-100 d-flex flex-column justify-content-center align-items-stretch" >
                  <div className="w-100 h-100 d-flex flex-column p-3 rounded" style={{border:"1px solid rgb(176, 171, 174)"}}>
                    <div className="d-flex flex-column flex-grow-1">
                      <div className="d-flex align-items-start h-100 ">
                      <FaChartBar size={32} style={{ color: "black" }} className="me-3" />
                        <div className="flex-grow-1">
                          <div className="fs-5 fw-normal">Prohibited AI Systems</div>
                          <div>Systems that violate fundamental rights (e.g., social scoring by governments, manipulative practices, or unlawful biometric surveillance).</div>
                        </div>
                      </div>
                    </div>
                  </div>
              </Col>
              <Col  md={6} className="mb-4 w-100 d-flex flex-column justify-content-center align-items-stretch" >
                  <div className="w-100 h-100 d-flex flex-column p-3 rounded" style={{border:"1px solid rgb(176, 171, 174)"}}>
                    <div className="d-flex flex-column flex-grow-1">
                      <div className="d-flex align-items-start h-100 ">
                      <FaSearch size={32} style={{ color: "black" }} className="me-3" />
                        <div className="flex-grow-1">
                          <div className="fs-5 fw-normal ">High-Risk AI Systems</div>
                          <div>AI applications in critical areas like healthcare, finance, public safety, and education. These require stringent compliance, including risk assessments, transparency, and oversight.</div>
                        </div>
                      </div>
                    </div>
                  </div>
              </Col>
              <Col  md={6} className="mb-4 w-100 d-flex flex-column justify-content-center align-items-stretch" >
                  <div className="w-100 h-100 d-flex flex-column p-3 rounded" style={{border:"1px solid rgb(176, 171, 174)"}}>
                    <div className="d-flex flex-column flex-grow-1">
                      <div className="d-flex align-items-start h-100 ">
                      <FaCog size={32} style={{ color: "black" }} className="me-3" />
                        <div className="flex-grow-1">
                          <div className="fs-5 fw-normal">Limited Risk AI Systems</div>
                          <div>Systems requiring transparency, such as chatbots, AI generated content. Must inform users they are interacting with AI.</div>
                        </div>
                      </div>
                    </div>
                  </div>
              </Col>
              <Col  md={6} className="mb-4 w-100 d-flex flex-column justify-content-center align-items-stretch" >
                  <div className="w-100 h-100 d-flex flex-column p-3 rounded" style={{border:"1px solid rgb(176, 171, 174)"}}>
                    <div className="d-flex flex-column flex-grow-1">
                      <div className="d-flex align-items-start h-100 ">
                      <FaShieldAlt size={32} style={{ color: "black" }} className="me-3" />
                        <div className="flex-grow-1">
                          <div className="fs-5 fw-normal">Minimal Risk AI Systems</div>
                          <div>Systems like spam filters, AI in video games, which are largely unregulated.</div>
                        </div>
                      </div>
                    </div>
                  </div>
              </Col>
            {/* ))} */}
          </Row>
        </div>
             
      <div className="head-font section-padding inline-padding">
      <h2 className="display-4 display-md-4 display-sm-6 fs-sm-5 fw-normal  text-md-center text-center mb-5 pb-3 head-font">Cost of Non Compliance</h2>
        {/* <h2 className="text-center mb-5 head-font py-4 text-weight">Cost of Non Compliance</h2> */}
      <p className="lead mb-4 d-flex align-items-center justify-content-center">
              <ul className="d-flex w-100 align-items-center justify-content-center gap-5 media-column" style={{ listStyleType: "none"}}>
               <li className="d-flex align-items-center justify-content-center media-width">
                  <div className="w-100 d-flex align-items-center justify-content-center flex-column fs-3 fw-bolder">Non Compliance <span className="w-100 d-flex align-items-center justify-content-center">Penalty</span>
                  </div>
               </li>
               <li className="d-flex align-items-center justify-content-center media-width">
                <div className="w-100 d-flex align-items-center justify-content-center flex-column fw-bolder media-font">€35 <span style={{color:"black"}} className="fs-5"> million
                </span></div>
               </li>
               <li className="d-flex align-items-center justify-content-center media-width">
                  <div className="w-100 d-flex align-items-center justify-content-center flex-column fw-bolder media-font">7%  <br/> <span className="fs-5" style={{color:"black"}}>of global annual turnover</span></div>
               </li>
              </ul>
            </p>
      </div>


{/* faq section */}
      <div className=" section-padding inline-padding" id="accordian">
      <h2 className="display-4 display-md-4 display-sm-6 fs-sm-5 fw-normal  text-md-center text-center mb-5 pb-3 head-font">Frequently Asked Questions</h2>
        {/* <h2 className="text-center mb-5 head-font py-4 text-weight">Frequently Asked Questions</h2> */}
      <Accordion>
     {
      data3?.map((opt,ind)=>{
        return  <Accordion.Item eventKey={ind} >
        <Accordion.Header>{opt.header}</Accordion.Header>
        <Accordion.Body style={{backgroundColor:"#f5f1f3"}}>
        {opt.content}
        <br/>
        <div className="w-100 py-3 d-flex align-items-center justify-content-center">
          {opt.images && <img className="" src={opt.images} alt="previewimg"/>}
        </div>
        </Accordion.Body>
    </Accordion.Item>
      })
     }
     
    </Accordion>
      </div>

        {/* bottom section */}
        <div className="text-center inline-padding section-padding my-5 h2">
        <h2 className="display-4 display-md-4 display-sm-6 fs-sm-5 fw-normal  text-md-center text-center mb-5 pb-3 head-font">Assess Your AI Compliance</h2>
          {/* <h2 className="mb-3 text-weight head-font">Assess Your AI Compliance</h2> */}
          <p className="lead text-muted mb-4 fs-5 fw-normal pb-5">
            Take the first step in ensuring your AI systems are compliant and
            risk-free.
          </p>
          <Button
            className="rounded py-2 px-3 text-white fs-5 custom-button new-btn"
            
            size="lg"
            onClick={handleShowModal}
            // onMouseEnter={() => setBgColor("rgb(136, 38, 87)")}
            // onMouseLeave={() => setBgColor("rgb(180, 25, 102)")}
          >
            Start Assessment
            <ArrowRight className="ms-3 h-4 w-4" />
          </Button>
         
        </div>
      {/* </motion.section> */}
      
    </div>
    </motion.section>
  );
};

export default EUAIActLandingPage;
